import * as React from 'react';
import FoodWaste from './FoodWaste';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter, WithRouterProps } from 'react-router';
import { Basis, ReportActions } from 'redux/ducks/reportFilter';
import * as reportsDispatch from 'redux/ducks/reportFilter';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import {
  AccountPointFilterWithNames,
  getFilter,
  getSelectedAccountNames
} from 'redux/ducks/reportFilter/selectors';
import { useDownloadReportPDF } from 'pages/Report/utils/useDownloadPDF';
import DownloadBtn from 'pages/Report/components/DownloadBtn';
import { getChartPNGs } from 'pages/Report/FoodWaste/utils/generateChartImages';
import { RootState } from 'redux/rootReducer';
import { ThunkDispatch } from 'redux-thunk';
import { CHART_COLORS } from 'pages/Report';

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

type FoodWasteContainerProps = StateProps &
  DispatchProps &
  RouteComponentProps<{ basis: Basis }, unknown>;

// only one that requires basis read from url, perhaps something we can change at some point to simplify logic,
// unless really necessary to expose foodwaste/per-guest as separate url
const FoodWasteContainer: React.FunctionComponent<FoodWasteContainerProps> = (props) => {
  const intl = useIntl();
  const {
    chartRefs,
    params: { basis: requestedBasis = 'total' },
    foodWasteStatus,
    foodWasteMetrics,
    foodWasteOverview,
    setBasis,
    filter: {
      basis,
      dimension,
      timeRange: { from: startDate, to: endDate }
    },
    filter,
    selectedRegistrationPoints,
    selectedAccountNames
  } = props;

  const [isDownloading, downloadPDF] = useDownloadReportPDF({
    generateChartPNG: () => getChartPNGs({ chartRefs, filter }),
    reportData: {
      AsyncDocument: async () => (await import('./PDF')).default,
      data: {
        chartColors: CHART_COLORS,
        foodWasteStatus,
        foodWasteMetrics,
        foodWasteOverview,
        filter,
        selectedRegistrationPoints,
        selectedAccountNames,
        intl
      },
      basis,
      dimension,
      name: `foodwaste-${startDate}-${endDate}`
    }
  });

  useEffect(() => {
    if (filter.isInitialized && basis !== requestedBasis) {
      setBasis(requestedBasis);
    }
  }, [requestedBasis]);

  return (
    (!filter.isInitialized || basis === requestedBasis) && (
      <FoodWaste
        key={'foodwaste-' + basis}
        basis={basis}
        downloadButton={<DownloadBtn isDownloading={isDownloading} onClick={downloadPDF} />}
        filter={filter}
      />
    )
  );
};

const mapStateToProps = (state: RootState) => {
  const accountPointFilter: AccountPointFilterWithNames = getFilter(state);

  return {
    chartRefs: state.charts.chartRefs,
    foodWasteStatus: state.reportData.foodWasteStatus.data,
    foodWasteMetrics: state.reportData.foodWasteMetrics.data,
    foodWasteOverview: state.reportData.foodWasteOverview.data,
    filter: state.reportFilter,
    selectedRegistrationPoints: accountPointFilter.selectedRegistrationPoints,
    selectedAccountNames: getSelectedAccountNames(state)
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, void, ReportActions>) => ({
  setBasis: (basis: Basis) => dispatch(reportsDispatch.changeBasis(basis))
});

export default withRouter(
  connect<StateProps, DispatchProps, WithRouterProps>(
    mapStateToProps,
    mapDispatchToProps
  )(FoodWasteContainer)
);
